/**
 * The Tonnie symbol, white and faint (7%), bleeding off the bottom-right corner
 * of a brand surface — the mark the sign-in panel carries, and the citizen
 * Home's hero cards with it, so every brand surface reads as one product. The
 * phone's `BrandWatermark` is the same mark.
 *
 * Decoration only: no alt text, no pointer events. The parent is `relative`
 * and `overflow-hidden`, and keeps its content above it (`relative`).
 */
import { getBrandLogoExtended } from '@tonnie/assets';

import { cn } from '../lib/utils';

export function BrandWatermark({ className }: { className?: string }) {
  return (
    <img
      src={getBrandLogoExtended('symbolWhite')}
      alt=""
      aria-hidden="true"
      data-testid="brand-watermark"
      className={cn(
        'pointer-events-none absolute -bottom-20 -right-20 h-72 w-72 select-none opacity-[0.07]',
        className
      )}
    />
  );
}
